import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
    trainingClassList: {
        requesting: false,
        items: [],
        pagination: {
            current_page: 1,
            per_page: 10,
            total: 0,
        },
        error: null,
        success: false,
        filters: {},
    },
    
    trainingClassDetails: {
        requesting: false,
        error: null,
        success: false,
        data: null
    },
    //
    trainingClassModuleList: {
        requesting: false,
        items: [],
        pagination: {
            current_page: 1,
            per_page: 10,
            total: 0,
        },
        error: null,
        success: false,
        filters: {},
    },
    trainingClassModuleDetails: {
        requesting: false,
        error: null,
        success: false,
        data: null
    },
    //
    trainingClassParticipantList: {
        requesting: false,
        items: [],
        pagination: {
            current_page: 1,
            per_page: 10,
            total: 0,
        },
        error: null,
        success: false,
        filters: {},
    },
    trainingClassParticipantDetails: {
        requesting: false,
        error: null,
        success: false,
        data: null
    },
    //
     //
    trainingModuleResultList: {
        requesting: false,
        items: [],
        pagination: {
            current_page: 1,
            per_page: 10,
            total: 0,
        },
        error: null,
        success: false,
        filters: {},
    },
    trainingModuleResultDetails: {
        requesting: false,
        error: null,
        success: false,
        data: null
    },
    //
  };

export const trainingClassSlice = createSlice({
  name: 'trainingClass',
  initialState,
  reducers: {
    getTrainingClassList: (state, action) => {
        state.trainingClassList.requesting = true;
        state.trainingClassList.error = null;
        state.trainingClassList.items = [];
        state.trainingClassList.success = false;
        state.trainingClassList.filters = action.payload;
    },
    getTrainingClassListSuccess: (state, action) => {
        const { data, current_page, per_page, total} = action.payload;
        state.trainingClassList.requesting = false;        
        state.trainingClassList.items = data;
        state.trainingClassList.success = true; 
        state.trainingClassList.pagination.current_page = current_page;
        state.trainingClassList.pagination.per_page = per_page;
        state.trainingClassList.pagination.total = total;
    },
    getTrainingClassListFail: (state, action) => {        
        state.trainingClassList.requesting = false;
        state.trainingClassList.error = action.payload;
    },
    getTrainingClassDetails: (state) => {
        state.trainingClassDetails.requesting = true;
        state.trainingClassDetails.error = null;
        state.trainingClassDetails.data = null;
        state.trainingClassDetails.success = false; 
    },
    getTrainingClassDetailsSuccess: (state, action) => {
        state.trainingClassDetails.requesting = false;
        state.trainingClassDetails.data = action.payload;
        state.trainingClassDetails.success = true; 
    },
    getTrainingClassDetailsFail: (state, action) => {        
        state.trainingClassDetails.requesting = false;
        state.trainingClassDetails.error = action.payload;
    },
    doTrainingClassCreate: (state) => {
        state.trainingClassDetails.requesting = true;
        state.trainingClassDetails.error = null;
        state.trainingClassDetails.data = null;
        state.trainingClassDetails.success = false; 
    },
    doTrainingClassUpdate: (state) => {
        state.trainingClassDetails.requesting = true;
        state.trainingClassDetails.error = null;
        state.trainingClassDetails.data = null;
        state.trainingClassDetails.success = false; 
    },
    doTrainingClassDelete: (state) => {
        state.trainingClassDetails.requesting = true;
        state.trainingClassDetails.error = null;
        state.trainingClassDetails.data = null;
        state.trainingClassDetails.success = false; 
    },

    doTrainingClassReset: (state) => {		
      state.trainingClassDetails.data = null;
    },

     // for class modules
    getTrainingClassModuleList: (state, action) => {
        state.trainingClassModuleList.requesting = true;
        state.trainingClassModuleList.error = null;
        state.trainingClassModuleList.items = [];
        state.trainingClassModuleList.success = false;
        state.trainingClassModuleList.filters = action.payload;
    },
    getTrainingClassModuleListSuccess: (state, action) => {
		const { data, current_page, per_page, total} = action.payload;
        state.trainingClassModuleList.requesting = false;        
        state.trainingClassModuleList.items = data;
        state.trainingClassModuleList.success = true; 
        state.trainingClassModuleList.pagination.current_page = current_page;
        state.trainingClassModuleList.pagination.per_page = per_page;
        state.trainingClassModuleList.pagination.total = total;
    },
    getTrainingClassModuleListFail: (state, action) => {        
        state.trainingClassModuleList.requesting = false;
        state.trainingClassModuleList.error = action.payload;
    },
    getTrainingClassModuleDetails: (state) => {
        state.trainingClassModuleDetails.requesting = true;
        state.trainingClassModuleDetails.error = null;
        state.trainingClassModuleDetails.data = null;
        state.trainingClassModuleDetails.success = false; 
    },
    getTrainingClassModuleDetailsSuccess: (state, action) => {
        state.trainingClassModuleDetails.requesting = false;
        state.trainingClassModuleDetails.data = action.payload;
        state.trainingClassModuleDetails.success = true; 
    },
    getTrainingClassModuleDetailsFail: (state, action) => {        
        state.trainingClassModuleDetails.requesting = false;
        state.trainingClassModuleDetails.error = action.payload;
    },
    doTrainingClassModuleCreate: (state) => {
        state.trainingClassModuleDetails.requesting = true;
        state.trainingClassModuleDetails.error = null;
        state.trainingClassModuleDetails.data = null;
        state.trainingClassModuleDetails.success = false; 
    },
    doTrainingClassModuleUpdate: (state) => {
        state.trainingClassModuleDetails.requesting = true;
        state.trainingClassModuleDetails.error = null;
        state.trainingClassModuleDetails.data = null;
        state.trainingClassModuleDetails.success = false; 
    },
    doTrainingClassModuleDelete: (state) => {
        state.trainingClassModuleDetails.requesting = true;
        state.trainingClassModuleDetails.error = null;
        state.trainingClassModuleDetails.data = null;
        state.trainingClassModuleDetails.success = false; 
    },

    // for class participants
    getTrainingClassParticipantList: (state, action) => {
        state.trainingClassParticipantList.requesting = true;
        state.trainingClassParticipantList.error = null;
        state.trainingClassParticipantList.items = [];
        state.trainingClassParticipantList.success = false;
        state.trainingClassParticipantList.filters = action.payload;
    },
    getTrainingClassParticipantListSuccess: (state, action) => {
		const { data, current_page, per_page, total} = action.payload;
        state.trainingClassParticipantList.requesting = false;        
        state.trainingClassParticipantList.items = data;
        state.trainingClassParticipantList.success = true; 
        state.trainingClassParticipantList.pagination.current_page = current_page;
        state.trainingClassParticipantList.pagination.per_page = per_page;
        state.trainingClassParticipantList.pagination.total = total;
    },
    getTrainingClassParticipantListFail: (state, action) => {        
        state.trainingClassParticipantList.requesting = false;
        state.trainingClassParticipantList.error = action.payload;
    },
    getTrainingClassParticipantDetails: (state) => {
        state.trainingClassParticipantDetails.requesting = true;
        state.trainingClassParticipantDetails.error = null;
        state.trainingClassParticipantDetails.data = null;
        state.trainingClassParticipantDetails.success = false; 
    },
    getTrainingClassParticipantDetailsSuccess: (state, action) => {
        state.trainingClassParticipantDetails.requesting = false;
        state.trainingClassParticipantDetails.data = action.payload;
        state.trainingClassParticipantDetails.success = true; 
    },
    getTrainingClassParticipantDetailsFail: (state, action) => {        
        state.trainingClassParticipantDetails.requesting = false;
        state.trainingClassParticipantDetails.error = action.payload;
    },
    doTrainingClassParticipantCreate: (state) => {
        state.trainingClassParticipantDetails.requesting = true;
        state.trainingClassParticipantDetails.error = null;
        state.trainingClassParticipantDetails.data = null;
        state.trainingClassParticipantDetails.success = false; 
    },
    doTrainingClassParticipantUpdate: (state) => {
        state.trainingClassParticipantDetails.requesting = true;
        state.trainingClassParticipantDetails.error = null;
        state.trainingClassParticipantDetails.data = null;
        state.trainingClassParticipantDetails.success = false; 
    },
    doTrainingClassParticipantDelete: (state) => {
        state.trainingClassParticipantDetails.requesting = true;
        state.trainingClassParticipantDetails.error = null;
        state.trainingClassParticipantDetails.data = null;
        state.trainingClassParticipantDetails.success = false; 
    },
    
    // for class results
    getTrainingModuleResultList: (state, action) => {
        state.trainingModuleResultList.requesting = true;
        state.trainingModuleResultList.error = null;
        state.trainingModuleResultList.items = [];
        state.trainingModuleResultList.success = false;
        state.trainingModuleResultList.filters = action.payload;
    },
    getTrainingModuleResultListSuccess: (state, action) => {
		const { data, current_page, per_page, total} = action.payload;
        state.trainingModuleResultList.requesting = false;        
        state.trainingModuleResultList.items = data;
        state.trainingModuleResultList.success = true; 
        state.trainingModuleResultList.pagination.current_page = current_page;
        state.trainingModuleResultList.pagination.per_page = per_page;
        state.trainingModuleResultList.pagination.total = total;
    },
    getTrainingModuleResultListFail: (state, action) => {        
        state.trainingModuleResultList.requesting = false;
        state.trainingModuleResultList.error = action.payload;
    },
    getTrainingModuleResultDetails: (state) => {
        state.trainingModuleResultDetails.requesting = true;
        state.trainingModuleResultDetails.error = null;
        state.trainingModuleResultDetails.data = null;
        state.trainingModuleResultDetails.success = false; 
    },
    getTrainingModuleResultDetailsSuccess: (state, action) => {
        state.trainingModuleResultDetails.requesting = false;
        state.trainingModuleResultDetails.data = action.payload;
        state.trainingModuleResultDetails.success = true; 
    },
    getTrainingModuleResultDetailsFail: (state, action) => {        
        state.trainingModuleResultDetails.requesting = false;
        state.trainingModuleResultDetails.error = action.payload;
    },
    doTrainingModuleResultCreate: (state) => {
        state.trainingModuleResultDetails.requesting = true;
        state.trainingModuleResultDetails.error = null;
        state.trainingModuleResultDetails.data = null;
        state.trainingModuleResultDetails.success = false; 
    },
    doTrainingModuleResultUpdate: (state) => {
        state.trainingModuleResultDetails.requesting = true;
        state.trainingModuleResultDetails.error = null;
        state.trainingModuleResultDetails.data = null;
        state.trainingModuleResultDetails.success = false; 
    },
    doTrainingModuleResultDelete: (state) => {
        state.trainingModuleResultDetails.requesting = true;
        state.trainingModuleResultDetails.error = null;
        state.trainingModuleResultDetails.data = null;
        state.trainingModuleResultDetails.success = false; 
    },
  },
})

export const { 
    // Training Class
    getTrainingClassList, 
    getTrainingClassListSuccess, 
    getTrainingClassListFail,
    getTrainingClassDetails, 
    getTrainingClassDetailsSuccess, 
    getTrainingClassDetailsFail,
    doTrainingClassCreate, 
    doTrainingClassUpdate, 
    doTrainingClassDelete,
    doTrainingClassReset,

    // Class Module
    getTrainingClassModuleList, 
    getTrainingClassModuleListSuccess, 
    getTrainingClassModuleListFail,
    getTrainingClassModuleDetails, 
    getTrainingClassModuleDetailsSuccess, 
    getTrainingClassModuleDetailsFail,
    doTrainingClassModuleCreate, 
    doTrainingClassModuleUpdate, 
    doTrainingClassModuleDelete,

    // Class Participant
    getTrainingClassParticipantList, 
    getTrainingClassParticipantListSuccess, 
    getTrainingClassParticipantListFail,
    getTrainingClassParticipantDetails, 
    getTrainingClassParticipantDetailsSuccess, 
    getTrainingClassParticipantDetailsFail,
    doTrainingClassParticipantCreate, 
    doTrainingClassParticipantUpdate, 
    doTrainingClassParticipantDelete,

    // Class Result
    getTrainingModuleResultList, 
    getTrainingModuleResultListSuccess, 
    getTrainingModuleResultListFail,
    getTrainingModuleResultDetails, 
    getTrainingModuleResultDetailsSuccess, 
    getTrainingModuleResultDetailsFail,
    doTrainingModuleResultCreate, 
    doTrainingModuleResultUpdate, 
    doTrainingModuleResultDelete,
} = trainingClassSlice.actions;

export default trainingClassSlice.reducer;
